import { ArticleType } from '@wix/answers-api';
import { useStore } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { useCurrentPage } from '../../common/hooks/useCurrentPage';
import { selectGenerateAnswerResult } from '../../common/selectors/answersGeneration';
import { selectSearchSessionId } from '../../common/selectors/helpCenter';
import { selectSolutions } from '../../common/selectors/solutions';
import { appRoutes } from '../../routes';
import { biLogger } from '../biLogger';
import { convertArticleType, pageEnumToString, solutionInfoPageMapper } from '../utils';

type ClickOnAnswerOrResultParams = {
  id: string;
  position: number;
  articleType: ArticleType;
  articleUrl?: string;
  distance?: number;
  searchMethod?: string;
};

export const useLogHelpWidgetClickOnAnswerOrResult = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('query');
  const store = useStore();
  const currentPage = useCurrentPage();

  const logClickOnAnswerOrResult = async ({
    id,
    position,
    articleType,
    articleUrl,
    distance,
    searchMethod,
  }: ClickOnAnswerOrResultParams) => {
    const state = store.getState();
    const solutions = selectSolutions(state);
    const searchSessionId = selectSearchSessionId(state);
    const solutionInfo = solutionInfoPageMapper[currentPage](state);
    const widgetPageType = pageEnumToString(currentPage);
    const answerGenResult = selectGenerateAnswerResult(state);

    const hasGeneratedAnswer = answerGenResult && (answerGenResult.answer || answerGenResult.prohibited);
    let answerType = solutions && solutions.length ? 'list' : 'empty';

    if (hasGeneratedAnswer) {
      answerType = 'generated answer';
    }

    await biLogger.helpWidgetClickOnAnswerOrResultNew(state, {
      search_method: searchMethod,
      answer_type: answerType,
      clicked_item_id: id,
      clicked_item_order_value: position + 1,
      clicked_item_type: convertArticleType(articleType),
      clicked_output_distance_str: distance ? distance.toString() : undefined,
      clicked_url: articleUrl || appRoutes.articleById({ articleId: id }),
      searched_text: query ?? undefined,
      widget_page_type: widgetPageType,
      presented_content: JSON.stringify(solutionInfo ?? null),
      search_session_id: searchSessionId,
    });
  };

  return { logClickOnAnswerOrResult };
};
